export default "__VITE_ASSET__CPYfYiep__"